import React, { useContext, useState } from "react"
import FlexView from "react-flexview/lib"
import { Grid, TextField } from "@material-ui/core"
import './Login.scss'
import { useForm } from "react-hook-form"
import NewFillButton from '../Core/NewFillButton';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';
import { SessionContextStore } from "../../context/SessionContext"
import { awaitWithLoading, isInFlow } from "../../services/utils"
import { useLocation, useHistory } from "react-router-dom"
import { EventEmitterService, EventKey } from "../../services/EventEmitterService"
import { SessionService } from "../../services/SessionService"
import insuranceApi from "../../api/insurance.api"
import { EMAIL_REGEX } from "../../Constants"
import { isMobile } from "react-device-detect";
import { SuccessfulLogin } from "./SuccessfulLogin"
import { ReactComponent as GmailIcon } from '../../assets/gmail_icon.svg';

export const LoginSection = (props) => {
    const { register, triggerValidation, errors, getValues, clearError,setError } = useForm()
    const sessionContext = useContext(SessionContextStore)
    const location = useLocation()
    const history = useHistory()
    const isInClaimsFlow = location.pathname.includes('claim');
    const [isSuccessfulLogin, setIsSuccessfulLogin] = useState(false)
    const [currEmail,setCurrEmail] = useState('')


    const onFBLogin = async (response) => {
        if(response.email && response.accessToken) {
          let res = await socialLogin(response.email, response.accessToken, "facebook");

          if(window.FB) 
            window.FB.logout()

          if(res.ok)   
            redirectAfterLogin()
          else      
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    React.useEffect(() => {
        const zendeskIFrame = document.getElementById('launcher')
        if (zendeskIFrame) zendeskIFrame.style = `display: none;`
      }, [])

    const onGoogleLogin = async (response) => {
        if(response.tokenId) {
          let res = await socialLogin(response.profileObj.email, response.tokenId, "google");
          if(res.ok)
            redirectAfterLogin()
          else      
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }


    const onEmailLogin = async () => {
        let valid = await triggerValidation()
        if(!valid) return
        clearError('email')
        setCurrEmail(getValues().email)
        let res = await awaitWithLoading(sessionContext.login(getValues().email,isInClaimsFlow))
        window.clarityUpdateUserId(getValues().email)

        if(res.ok) {
            setIsSuccessfulLogin(true)
        }
        else {
            setError('email',res.data.title)
        }
        
    }

    const socialLogin = async (email, token, serviceName) => {
        return await awaitWithLoading(sessionContext.socialLogin(email, token, serviceName))
    }

    const redirectAfterLogin = async () => {
        if(isInFlow(location.pathname) && props.afterLogin)
            props.afterLogin()
        else if(SessionService.isBroker())
            history.push('/broker')
        else {
            if (location.state && location.state.from && location.state.from.pathname.startsWith("/policy-management")){
                history.push({pathname: `${location.state.from.pathname}`, search: location.state.from.search})
                return;
            }
            
            let res = await insuranceApi.getActiveInsurances()
            
            if(res.ok && res.parsedData) 
                history.push(`/policy-management`)
            else
                history.push('/insurance/monthly')
        }
    }

    const onEnterPressed = event => {
        event.key == 'Enter' && onEmailLogin()
    }





    return <React.Fragment>
       {isSuccessfulLogin?
        <SuccessfulLogin onBack={() => setIsSuccessfulLogin(false)} onResend={()=> awaitWithLoading(sessionContext.login(currEmail,isInClaimsFlow))}/>
        : 
        <div className={` space-between flex col full-height `}>
            <div className={`${isMobile && 'padding-top-basic'}`}>

            <div className="gap-12 flex col">

        <div className="title">
            Welcome Back
        </div>

        <div className="sub-title gray-text">
            Welcome Back! Please enter your details
        </div>
            </div>
            <FlexView hAlignContent={'center'} className="margin-top-medium gap-8">
                <FacebookLogin
                    appId="494398664296343"
                    fields="email"
                    textButton=""
                    autoLoad={false}
                    isMobile={false} 
                    callback={onFBLogin}
                    containerStyle={{
                        borderRadius: '8px', // Match the border radius in the image
                        backgroundColor: '#ffffff', // Set background to white
                        border: '1px solid #D0D5DD', // Set border color
                        width: '45px',
                        height: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0,
                        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
                    }}
                    buttonStyle={{
                        backgroundImage: `url(${require('../../assets/facebook-icon.svg')})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '50%',
                        width: '75%',
                        height: '75%',
                        border: 'none',
                        padding: 0,
                        margin: 0,
                        cursor: 'pointer'
                      }}
                    />
                <GoogleLogin 
                    clientId="734682503233-v89okd2g9fe0d1nlgv9dv0n74hiu99nu.apps.googleusercontent.com"
                    buttonText=""
                    autoLoad={false}
                    className="google-btn center max-h-45 max-w-45 clickable"
                    cookiePolicy={'single_host_origin'}
                    onSuccess={onGoogleLogin}
                    onFailure={onGoogleLogin} 
                    render={renderProps => (
                        <button
                            onClick={renderProps.onClick}
                            disabled={renderProps.disabled}
                            className="google-button-custom"
                        >
                            <GmailIcon/>
                        </button>
                    )}
                    />
                </FlexView>
            <div className="text-body black textcenter margin-top-medium margin-bottom-small gray-text">Or</div>
        <TextField onKeyPress={onEnterPressed} fullWidth variant="outlined" type="email" className="margin-top-basic " label="Email" name="email" inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "Invalid email address"}})} helperText={!!errors.email && (errors.email.message || errors.email.type)} error={!!errors.email} />


       <NewFillButton onClick={onEmailLogin}>Login</NewFillButton>
       </div>

       <div className="flex gap-5 margin-top-basic content-center padding-bottom-basic poppins">
                <div className=" black textcenter ">Don't have an account?  </div>
                <div onClick={()=> history.push('/insurance')} className=" blue underline textcenter clickable">Create a new account</div>
            </div>
            </div>}

    </React.Fragment>
}

export const Login = (props) => {
    
    return (<>
        <Grid container className="page content-center ">
            <div className={`${!isMobile &&  'self-center margin-basic'}`}>
                <LoginSection {...props}  /> 
            </div>
        </Grid>
    </>
    )
}